//
// Module for the Notifications Index view
//
rs.module("content/user/notificationhistory/notifications/index",

    [],

    function () {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, readCodeValue, gridNameValueMarker) {

            var form = $.js(jsSelectors.markReadForm);

            var markReadButton = form.js(jsSelectors.readButton);
            var keys = form.js(jsSelectors.detailKeys);

            keys.ready(function () {
                keys.val("");
            });

            $(document).onjs("click", jsSelectors.viewLink, function () {
                // This only sets the status visually. Viewing the notification in DocumentController's View action makes the backend call to actually set it.
                var id = $(this).closest("div[role='row']")[0].attributes["row-id"].value;
                var rowNode = lrsGridApi.agGridApi.getRowNode(id);
                rowNode.setDataValue('AlertDetailStatus', [readCodeValue.Key, readCodeValue.Name, gridNameValueMarker]);
            });

            markReadButton.click(function(){
                lrsGridApi.agGridApi.forEachNodeAfterFilter(addKey);
            });

            function addKey(node) {
                if (!keys.val()) {
                    keys.val(node.data.AlertDetailKey);
                }
                else {
                    keys.val(keys.val() + "," + node.data.AlertDetailKey);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);  